import { useState } from 'react'

import getAvatarUrl from '../../../../helpers/getAvatarUrl'

import { imagePrefix } from '../../../../constants'

const JobPostModalImages = ({ job }) => {
  const [activeImage, setActiveImage] = useState(null)

  const firstImage = job.images?.[0]
  const restImages = job.images?.slice?.(1, 5) || []

  const handleChangeActiveImage = (url) => {
    setActiveImage((prevState) => {
      if (prevState === url) {
        return null
      }

      return url
    })
  }

  const restImagesContent = restImages.map((restImage, index) => {
    const url = restImage
      ? `${typeof firstImage === 'string' ? imagePrefix : ''}${typeof restImage === 'string' ? restImage : getAvatarUrl(restImage.original)}`
      : ''
    const isActive = url === activeImage

    return (
      <button key={url} className="w-[calc(25%-9px)]" onClick={() => handleChangeActiveImage(url)}>
        <img
          src={url}
          alt={`Job image ${index + 2}`}
          draggable={false}
          className={`w-full h-[100px] rounded-[8px] object-cover border-[1px] transition-colors duration-200 ease ${isActive ? 'border-[#FFCA84]' : 'border-transparent'}`}
        />
      </button>
    )
  })

  return (
    <div className="w-full mt-[10px] flex flex-col items-start">
      <img
        src={
          activeImage ||
          (firstImage
            ? `${typeof firstImage === 'string' ? imagePrefix : ''}${typeof firstImage === 'string' ? firstImage : getAvatarUrl(firstImage.original)}`
            : '') ||
          ''
        }
        alt={job.job_title}
        className="w-full h-[364px] rounded-[10px] border-[#FFCA84] border-[1px] object-cover"
      />

      {!!restImages.length && (
        <div className="mt-[10px] w-full flex items-center flex-wrap gap-[12px]">
          {restImagesContent}
        </div>
      )}
    </div>
  )
}

export default JobPostModalImages
